"use strict";

define('rs/components/scroll-bottom',['vertebrae'], function (Vertebrae) {
  var ScrollBottom = function ScrollBottom(el, options, context) {
    var $el = $(el),
      isWindow = $el.get(0) === window,
      fn = null,
      defaults = null,
      handle = null;
    if (_.isFunction(options)) {
      fn = options;
      options = null;
    }
    defaults = {
      fn: fn,
      offset: 0,
      context: context
    };
    options = _.extend({}, defaults, options);
    handle = function handle(ev) {
      var child = isWindow ? $(document) : $el.children(0);
      if ($el.scrollTop() + $el.height() == child.height() - options.offset) {
        options.fn.call(options.context || this, el, ev);
      }
    };
    $el.on('scroll', null, handle);
    return {
      remove: function remove() {
        $el.off('scroll', handle);
      }
    };
  };
  return ScrollBottom;
});

